import { render } from "./generalTab.vue?vue&type=template&id=56d0bf2c&scoped=true"
import script from "./generalTab.vue?vue&type=script&setup=true&lang=js"
export * from "./generalTab.vue?vue&type=script&setup=true&lang=js"

import "./generalTab.vue?vue&type=style&index=0&id=56d0bf2c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d0bf2c"],['__file',"pages/EndataAuth/Account/App/components/profile/my/generalTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56d0bf2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56d0bf2c', __exports__)) {
    api.reload('56d0bf2c', __exports__)
  }
  
  module.hot.accept("./generalTab.vue?vue&type=template&id=56d0bf2c&scoped=true", () => {
    api.rerender('56d0bf2c', render)
  })

}


export default __exports__